const DEFAULT_PAYMENT_TERMS = 'Net 30';

function clean(value) {
  return String(value || '').trim();
}

function sameTerm(a, b) {
  return clean(a).toLowerCase() === clean(b).toLowerCase();
}

function shouldAutofillPaymentTerms({
  currentTerms,
  previousSupplierTerms,
  supplierTerms,
  manuallyEdited,
}) {
  if (manuallyEdited) return false;
  if (!clean(supplierTerms)) return false;
  if (!clean(currentTerms)) return true;
  if (sameTerm(currentTerms, DEFAULT_PAYMENT_TERMS)) return true;
  if (previousSupplierTerms && sameTerm(currentTerms, previousSupplierTerms)) return true;
  return false;
}

module.exports = {
  DEFAULT_PAYMENT_TERMS,
  shouldAutofillPaymentTerms,
};
